The scheme ID of the `WebhookSubscription` that generated the request.

This is used to determine which data source includes the `requestId`.

Currently, only `seekAnz` and `seekAnzPublicTest` are supported.
